import PropTypes from "prop-types"
import React from "react"
import { Table } from "semantic-ui-react"
import Variants from "components/Variants/Variants"
import productStore from "stores/productStore"



const ProductTechnicalTable = ( { product } ) => {


  
  return (
    
    <div className="pt4">
      <h4>Details</h4>
      <Table>
        <tbody>

        {product.quantities[ 0 ] &&
        <tr key={product.quantities[ 0 ].map_desc_id}>
          <td>
            <label>
              {product.quantities[ 0 ].des}
            </label>
          </td>
          <td>
            {product.quantities[ 0 ].multi} {translate( "product.piece" )}
          </td>
        </tr>
        }
        {product.extraValue.length != '' &&
        <tr>
          <td>
            <label>
              Länge
            </label>
          </td>
          <td>
            {product.extraValue.length}
          </td>
        </tr>
        } 
        {product.extraValue.width != '' &&
        <tr>
          <td>
            <label>
              Breite
            </label>
          </td>
          <td>
            {product.extraValue.width}
          </td>
        </tr>
        } 
        {product.extraValue.height != '' &&
        <tr>
          <td>
            <label>
              Höhe
            </label>
          </td>
          <td>
            {product.extraValue.height}
          </td>
        </tr>
        }
        {product.extraValue.diameter != '' &&
          <tr>
            <td>
              <label>
                Durchmesser
              </label>
            </td>
            <td>
              {product.extraValue.diameter}
            </td>
          </tr>
          } 
          <tr>
          <td>
            <label>
              EAN
            </label>
          </td>
          <td>
            {product.barcode}
          </td>
        </tr>

        {/*product.extras.isnew && <tr>
          <td>
            <label>
              Neuheit
            </label>
          </td>
          <td>
            {translate("Achtung Neuheit - nur vorbestellbar")}
          </td>
        </tr>*/}

        </tbody>
      </Table>
    </div>
  )
}



ProductTechnicalTable.propTypes = {
  product: PropTypes.object
}


export default ProductTechnicalTable


// WEBPACK FOOTER //
// ./src/theme/sandra/components/Product/ProductTechnicalTable.js